import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Step } from 'signup-constants/Step';
import TextAnimations from '../TextAnimations/TextAnimation';
import { useCopyCarousel } from '../app-active-loading/useCopyCarousel';
import styled from 'styled-components';
import { H3 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledH3 = styled(H3).withConfig({
  displayName: "CarouselTitle__StyledH3",
  componentId: "sc-161vzvs-0"
})(["font-size:26px;"]);
export const CarouselTitle = () => {
  const {
    copyToDisplay
  } = useCopyCarousel({
    baseI18n: `views.${Step.LandingPage}.acq164Title.title`,
    shouldGoRound: true,
    textSwitchingInterval: 5500
  });
  return /*#__PURE__*/_jsx(StyledH3, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `views.${Step.LandingPage}.acq164Title.base`,
      options: {
        useCase: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(TextAnimations, {
            text: I18n.text(`${copyToDisplay}`)
          })]
        })
      }
    })
  });
};